import TenDaysMVPWhat from './TenDaysMVPWhat';
export default TenDaysMVPWhat;
